import React, { useRef, useCallback } from 'react';
import '../../shared/utilities/highlightSetup';
import ReactQuill from 'react-quill';
import Resizer from "react-image-file-resizer";
import 'react-quill/dist/quill.snow.css';

import './RichTextEdit.css'

const RichTextEdit = ({
  contenido,
  setContenido,
  setFlagTextoRes,
  setErrorTamMax,
  onImageSizeErrors,
  onImageSelectionWarning,
}) => {
    const quillRef = useRef();
    const MAX_IMAGES = 5;
    const MAX_SIZE_BYTES = 5000000;

    const handleImageUpload = useCallback(async (file) => {
      return new Promise((resolve, reject) => {
        if(file.size > 4500000){
          Resizer.imageFileResizer(file, 450, 450, 'PNG', 5, 0,
            (uri) => { resolve(uri) },
            'base64'
          );
        }
        else if(file.size > 4000000){
          Resizer.imageFileResizer(file, 600, 600, 'PNG', 25, 0,
            (uri) => { resolve(uri) },
            'base64'
          );
        }
        else if(file.size > 3500000){
          Resizer.imageFileResizer(file, 700, 700, 'PNG', 35, 0,
            (uri) => { resolve(uri) },
            'base64'
          );
        }
        else if(file.size > 3000000){
          Resizer.imageFileResizer(file, 750, 750, 'PNG', 45, 0,
            (uri) => { resolve(uri) },
            'base64'
          );
        }
        else if(file.size > 2500000){
          Resizer.imageFileResizer(file, 900, 900, 'PNG', 55, 0,
            (uri) => { resolve(uri) },
            'base64'
          );
        }
        else if(file.size > 2000000){
          Resizer.imageFileResizer(file, 1000, 1000, 'PNG', 65, 0,
            (uri) => { resolve(uri) },
            'base64'
          );
        }
        else if(file.size > 1500000){
          Resizer.imageFileResizer(file, 1500, 1500, 'PNG', 80, 0,
            (uri) => { resolve(uri) },
            'base64'
          );
        }
        else if(file.size > 1000000){
          Resizer.imageFileResizer(file, 1700, 1700, 'PNG', 90, 0,
            (uri) => { resolve(uri) },
            'base64'
          );
        }
        else{
          Resizer.imageFileResizer(file, 2000, 2000, 'PNG', 100, 0,
            (uri) => { resolve(uri) },
            'base64'
          );
        }
      });
    }, []);

    const handleImageClick = useCallback(() => {
      const fileInput = document.createElement('input');
      fileInput.setAttribute('type', 'file');
      fileInput.setAttribute('accept', 'image/*');
      fileInput.setAttribute('multiple', 'true');
      fileInput.addEventListener('change', async () => {
        const selectedFiles = Array.from(fileInput.files || []);
        if (selectedFiles.length > MAX_IMAGES) {
          onImageSelectionWarning && onImageSelectionWarning({
            selected: selectedFiles.length,
            max: MAX_IMAGES,
          });
        }

        const files = selectedFiles.slice(0, MAX_IMAGES);
        if (files.length === 0) {
          fileInput.remove();
          return;
        }

        const editor = quillRef.current.getEditor();
        const range = editor.getSelection(true);
        let insertIndex = range ? range.index : editor.getLength();
        const tooLargeFiles = [];

        for (const file of files) {
          if (file.size > MAX_SIZE_BYTES) {
            tooLargeFiles.push(file);
            continue;
          }

          const imageUrl = await handleImageUpload(file);
          if (!imageUrl) {
            continue;
          }

          editor.insertEmbed(insertIndex, 'image', imageUrl, 'user');
          insertIndex += 1;
        }

        if (tooLargeFiles.length > 0) {
          if (onImageSizeErrors) {
            onImageSizeErrors(tooLargeFiles);
          } else if (setErrorTamMax) {
            setErrorTamMax(true);
          }
        }

        editor.setSelection(insertIndex, 'silent');
        fileInput.remove();
      });
      fileInput.click();
    }, [handleImageUpload, onImageSelectionWarning, onImageSizeErrors, setErrorTamMax]);

    const modules = {
      syntax: true,
      toolbar: {
        container: [
          ['bold', 'italic', 'underline', 'strike'], // negrita, cursiva, subrayado, tachado
          [{ color: [] }, { background: [] }], // color de texto, color de fondo
          [{ list: 'ordered' }, { list: 'bullet' }], // listas ordenadas, listas sin orden
          [{ align: [] }], // alineación
          [{ header: [1, 2, 3, 4, 5, 6, false] }], // tamaños de encabezado
          ['link', 'image', 'code-block'], // enlaces, imágenes
          ['clean'], // limpiar formatos
        ],
        handlers: {
          image: handleImageClick,
        },
      },
    };
    const formats = [
      'bold',
      'italic',
      'underline',
      'strike',
      'color',
      'background',
      'list',
      'bullet',
      'align',
      'header',
      'link',
      'image',
      'code-block',
    ];
    function handleChange(valor) {
      setContenido(valor);
      setFlagTextoRes(2);
    }

    return (
      <>
        <ReactQuill ref={quillRef} value={contenido} onChange={handleChange} modules={modules} formats={formats} />
      </>
    );
}

export default RichTextEdit;

